import type {Property} from '../../../../services/rest'
import {defaultValue} from '../Parameters.constants'

interface Props {
  parameters: readonly Property[]
  search: string
  original?: Record<string, string>
}

export function filterSearch(props: Props) {
  const {parameters, search, original} = props

  if (search.length === 0) {
    return parameters
  }

  return parameters.filter(parameter =>
    [
      parameter.name || defaultValue,
      parameter.value || defaultValue,
      parameter.name != null ? original?.[parameter.name] : undefined,
    ].some(value => value?.toLowerCase().includes(search.toLowerCase())),
  )
}
